import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = ({ allowedRoles = [], redirectPath = '/?login=required' }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // 1. Check LocalStorage first for instant feedback
        const storedUser = localStorage.getItem('paradise_user');
        if (storedUser) {
            setUser(JSON.parse(storedUser));
        }

        // 2. Validate with Backend (Essential for security)
        // We assume the token is stored in localStorage or handled by the browser
        // For this MVP, we rely on the localStorage user object having the roles
        // Ideally, we'd hit /api/me here to double-check.

        const verifySession = async () => {
            const token = localStorage.getItem('paradise_token'); // Assuming we store token here
            if (!token) {
                setLoading(false);
                return;
            }

            try {
                const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:4000';
                const res = await fetch(`${API_BASE}/api/me`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (res.ok) {
                    const data = await res.json();
                    setUser(data);
                    // Update local storage to keep in sync
                    localStorage.setItem('paradise_user', JSON.stringify(data));
                } else {
                    // Invalid token
                    localStorage.removeItem('paradise_user');
                    localStorage.removeItem('paradise_token');
                    setUser(null);
                }
            } catch (e) {
                console.error("Auth check failed", e);
            } finally {
                setLoading(false);
            }
        };

        verifySession();
    }, []);


    if (loading) {
        return <div className="flex items-center justify-center h-screen bg-black text-white font-mono text-xs">VERIFYING ACCESS...</div>;
    }

    if (!user) {
        // Not logged in -> Redirect to Apply? Or Home?
        // Since login is on Home, redirect to Home?
        return <Navigate to={redirectPath} replace />;
    }

    // Check Roles
    // user.roles array vs allowedRoles array
    const userRoles = user.roles || ['subscriber']; // Default
    const hasPermission = allowedRoles.some(role => userRoles.includes(role));

    if (!hasPermission) {
        return (
            <div className="flex flex-col items-center justify-center h-screen bg-black text-white font-mono text-center p-4">
                <h1 className="text-red-500 text-xl font-bold mb-4">ACCESS DENIED</h1>
                <p className="mb-2">INSUFFICIENT PERMISSIONS.</p>
                <div className="text-gray-500 text-xs border border-gray-800 p-4 rounded mt-4">
                    <p>Logged in as: <span className="text-white">{user.email}</span></p>
                    <p>Roles: <span className="text-white">{user.roles?.join(', ') || 'None'}</span></p>
                    <p>Required: <span className="text-white">{allowedRoles.join(', ')}</span></p>
                </div>
                <button
                    onClick={() => {
                        localStorage.removeItem('paradise_user');
                        localStorage.removeItem('paradise_token');
                        window.location.href = '/';
                    }}
                    className="mt-8 text-xs underline hover:text-red-500"
                >
                    Log Out & Retry
                </button>
            </div>
        );
    }

    return <Outlet />;
};

export default ProtectedRoute;
